import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Slider } from "@/components/ui/slider";
import { FINANCING_PATH } from "./data";
import { FIN, euro } from "@/content/financing";

export const InstallmentHint = () => {
  const [amount, setAmount] = useState(3000);
  const [rate, setRate] = useState(FIN.maxRate);
  return (
    <div className="rounded-2xl bg-[#0F2317] text-[#FCFBF7] p-6" data-testid="installment-hint">
      <p className="eyebrow text-[#86C89B]">Il costo ti preoccupa?</p>
      <p className="f-serif text-2xl leading-tight mt-3">Puoi pagare le cure fino a 24 rate, <em className="text-[#86C89B]">a interessi zero.</em></p>
      <div className="mt-6 flex items-baseline justify-between gap-3">
        <span className="text-sm text-[#FCFBF7]/75">Se le cure costano</span>
        <span className="f-mono text-sm" data-testid="installment-hint-amount">{euro(amount, 0)}</span>
      </div>
      <Slider value={[amount]} onValueChange={([v]) => setAmount(v)} min={FIN.min} max={FIN.max} step={100} className="mt-4 fin-slider" aria-label="Importo indicativo delle cure" data-testid="installment-hint-slider" />
      <div className="mt-5 flex gap-2" role="group" aria-label="Numero di rate">
        {[12, 18, 24].map((n) => (
          <button type="button" key={n} onClick={() => setRate(n)} data-testid={`installment-hint-rate-${n}`}
            className={`flex-1 rounded-full py-2 text-sm border transition-colors ${rate === n ? "bg-[#86C89B] border-[#86C89B] text-[#0F2317]" : "border-[#FCFBF7]/20 hover:border-[#86C89B]"}`}>
            {n} rate
          </button>
        ))}
      </div>
      <p className="mt-6 text-sm text-[#FCFBF7]/75">Rata indicativa</p>
      <p className="f-serif text-5xl leading-none mt-1 tabular-nums" data-testid="installment-hint-monthly">{euro(amount / rate)}<span className="text-lg text-[#FCFBF7]/75"> /mese</span></p>
      <p className="text-xs text-[#FCFBF7]/70 mt-3 leading-relaxed">TAN 0% · TAEG 0% · fino a 9.000 €. Il costo reale si definisce dopo la visita; finanziamento soggetto ad approvazione.</p>
      <Link to={`${FINANCING_PATH}?importo=${amount}&rate=${rate}`} data-testid="installment-hint-link"
        className="group mt-6 inline-flex items-center gap-2 text-sm text-[#86C89B] hover:text-[#FCFBF7] transition-colors">
        Simula o invia un preventivo <ArrowUpRight size={15} className="transition-transform duration-500 group-hover:rotate-45" />
      </Link>
    </div>
  );
};
